import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { Loading } from './Loading/Loading';

export interface ProtectedRouteProps {
    children: React.ReactNode;
    isAuthenticated: boolean | undefined;
}

export const ProtectedRoute = ({ children, isAuthenticated }: ProtectedRouteProps): React.ReactNode => {
    const location = useLocation();
    const { pathname } = location;

    if (isAuthenticated === undefined) {
        return <Loading />;
    }

    if (isAuthenticated !== undefined && !isAuthenticated) {
        if (pathname !== '/logout') {
            document.cookie = `cpage=${pathname}; SameSite=lax; path=/`;
        }
        return <Navigate to="/login" replace />;
    }
    return children;
};
